import { Icon } from '@/components/primitives';
import { STATE_PIPELINE, type AdjustmentState } from '@/domain';

interface Props {
  state: AdjustmentState;
}

export function StatePipeline({ state }: Props) {
  const isRejected = state === 'REJECTED';
  const activeIdx = STATE_PIPELINE.findIndex((s) => s.state === state);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'var(--bx-font-sans)',
      }}
    >
      {STATE_PIPELINE.map((step, i) => {
        const isActive = i === activeIdx;
        const isPast = i < activeIdx;

        return (
          <div key={step.state} style={{ display: 'flex', alignItems: 'center' }}>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 8px',
                borderRadius: 9999,
                fontSize: 11,
                fontWeight: 600,
                background: isActive
                  ? 'var(--bx-primary)'
                  : isPast
                    ? '#eef2ff'
                    : 'var(--bx-surface-2)',
                color: isActive
                  ? '#fff'
                  : isPast
                    ? 'var(--bx-primary)'
                    : 'var(--bx-text-muted)',
                opacity: isRejected && !isActive ? 0.4 : 1,
              }}
            >
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 14,
                  height: 14,
                  borderRadius: 9999,
                  background: isActive
                    ? '#fff'
                    : isPast
                      ? 'var(--bx-primary)'
                      : 'var(--bx-border-muted)',
                  color: isActive
                    ? 'var(--bx-primary)'
                    : isPast
                      ? '#fff'
                      : 'var(--bx-text-muted)',
                  fontSize: 9,
                }}
              >
                {isPast ? <Icon name="check" size={8} /> : i + 1}
              </span>
              {step.label}
            </div>
            {i < STATE_PIPELINE.length - 1 && (
              <div
                style={{
                  width: 16,
                  height: 1,
                  background: isPast ? 'var(--bx-primary)' : 'var(--bx-border-muted)',
                  opacity: isRejected ? 0.3 : 1,
                }}
              />
            )}
          </div>
        );
      })}
      {isRejected && (
        <div
          style={{
            marginLeft: 6,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '4px 8px',
            borderRadius: 9999,
            fontSize: 11,
            fontWeight: 600,
            background: 'var(--bx-error-bg)',
            color: 'var(--bx-error)',
          }}
        >
          <Icon name="x" size={9} />
          Từ chối
        </div>
      )}
    </div>
  );
}
